/**
 * YB-2315 — PAPI refuses a pass create / edit that picks a cancelled or expired pass as its Related
 * (`creator_pass_id`) with `errorCode: related_pass_inactive`. The picker never offers one, so this
 * is the case of a related that ended while the modal was open. The toast is built from the code,
 * never from `errorText` (PAPI's English).
 */
export const RELATED_PASS_INACTIVE = 'related_pass_inactive'

/** i18n key of the toast's text. */
export const RELATED_PASS_INACTIVE_MESSAGE = 'AUTHORIZED.FORMS.RELATED_STATUS.REFUSED'

/**
 * YB-2316 — PAPI refuses a related list it cannot save (more than 10, a repeat, or a pass that is not
 * an employee or authorized pass) with `errorCode: related_passes_invalid`. The picker prevents all
 * of these, so it is a safety net: the toast, again, is built from the code.
 */
export const RELATED_PASSES_INVALID = 'related_passes_invalid'

export const RELATED_PASSES_INVALID_MESSAGE = 'AUTHORIZED.FORMS.RELATED_PRIMARY.INVALID'
